import { Elements, useStripe } from "@stripe/react-stripe-js";
import { type StripeCardElement, type StripeElementsOptions, loadStripe } from "@stripe/stripe-js";
import { type PropsWithChildren, useCallback } from "react";

type StripeProps = PropsWithChildren<{
  elementsOptions?: StripeElementsOptions;
  publishableKey: string;
}>;

type CreateBankAccParams = {
  accountNumber: string;
  currency: string;
  type: string;
  country: string;
};

export const Provider = ({ elementsOptions, children, publishableKey }: StripeProps) => {
  const stripePromise = loadStripe(publishableKey, {
    locale: elementsOptions?.locale,
  });

  return (
    <Elements options={elementsOptions} stripe={stripePromise}>
      {children}
    </Elements>
  );
};

export const useCreateStripeBankAccount = () => {
  const stripe = useStripe();

  return useCallback(
    ({ accountNumber, ...rest }: CreateBankAccParams) => {
      if (!stripe?.createToken) {
        return Promise.resolve({
          error: { message: "Stripe not initialized" },
        });
      }

      // @ts-expect-error - Stripe typings are wrong
      return stripe.createToken("bank_account", {
        account_number: accountNumber,
        bank_account: { account_number: accountNumber },
        ...rest,
      });
    },
    [stripe?.createToken],
  );
};

export const useCreateCardToken = () => {
  const stripe = useStripe();

  return useCallback(
    (params: StripeCardElement) => {
      return stripe?.createToken(params);
    },
    [stripe?.createToken],
  );
};

export const useCreateStripePlatformPayToken = () => {
  return useCallback(() => {}, []);
};
